import React from "react"
import { useRoutes } from "react-router-dom"
import { SlaaskPlugin } from "@ui-seeker/slaask-plugin"
import 'rsuite/dist/rsuite-no-reset.min.css'
import 'react-multi-carousel/lib/styles.css'

import routes from "./Routes"
import AppTheme from "./Theme"
import { userData, username } from '@signals'


export default function App() {
	const elements = useRoutes(routes(userData.value))

	return <AppTheme>
		{elements}
		<SlaaskPlugin widgetKey="spk-d2358d18-33fd-40da-8da6-25fcf50b7577" name={username.value}/>
	</AppTheme>
}